import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { landingContainerClass } from './landing/LandingContainer';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-charcoal-900 text-white">
      <div className={`${landingContainerClass} py-10 sm:py-12`}>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-12">
          <div>
            <Logo linkTo="/" showAsLink={true} className="brightness-0 invert" />
            <p className="mt-3 max-w-sm text-sm leading-6 text-neutral-300">
              Paste one URL into an HTML form. Submissions and files land in your inbox.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-neutral-400">Product</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/docs" className="text-neutral-300 hover:text-white">Docs</Link></li>
              <li><Link to="/blog" className="text-neutral-300 hover:text-white">Blog</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-neutral-400">Company</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/terms" className="text-neutral-300 hover:text-white">Terms</Link></li>
              <li><Link to="/privacy" className="text-neutral-300 hover:text-white">Privacy</Link></li>
              <li><Link to="/accessibility" className="text-neutral-300 hover:text-white">Accessibility</Link></li>
              <li><Link to="/abuse" className="text-neutral-300 hover:text-white">Report abuse</Link></li>
            </ul>
          </div>
        </div>
        <p className="mt-10 border-t border-white/10 pt-6 text-sm text-neutral-400">
          © 2026 <a href="https://polozhevets.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-neutral-300">Polozhevets OÜ</a>. All rights reserved.
        </p>
      </div>
    </footer>
  );
} 